export const SeatsOptions = new Map([
  [1, "Single Seat"],
  [0, "Pair Seat"],
  [2, "Multiple Seat"]
]);
